import React from 'react'
import cn from 'classnames'

import metrics from 'util/metrics'

import SubsequentActionsList from './SubsequentActionsList'
import ExpandedMessageContent from './ExpandedMessageContent'
import ExpandedNoteContent from './ExpandedNoteContent'

import { handlePrintClick } from './util'

class ExpandedMessageView extends React.Component {
  componentDidMount() {
    const { message } = this.props
    metrics.stopTimer(`changeset-load-${message.id}`)
  }

  shouldComponentUpdate(nextProps) {
    const { message } = this.props
    const { message: nextMessage } = nextProps
    const actionsWereCount = message.subsequentActions
      ? message.subsequentActions.length
      : 0
    const actionsAreCount = nextMessage.subsequentActions
      ? nextMessage.subsequentActions.length
      : 0

    const should =
      message.id !== nextMessage.id || actionsAreCount !== actionsWereCount
    return should
  }

  onPrintClick = e => {
    e.stopPropagation()
    handlePrintClick(e)
  }

  onCopyLinkClick = e => {
    const { message, doShowSnackbar } = this.props
    const { origin, pathname } = window.location
    const messageURL = `${origin}${pathname}#changeset-${message.id}`
    if (!navigator.clipboard)
      return doShowSnackbar('Could not copy a link to the message.')
    navigator.clipboard
      .writeText(messageURL)
      .then(() =>
        doShowSnackbar('Link to the message was copied to your clipboard')
      )
    e.stopPropagation()
    return null
  }

  expandChangeset = () => {
    const { message, expand } = this.props
    expand(message.id)
  }

  render() {
    const {
      message,
      currentUserId,
      onOpenImage,
      integrationSettings,
      isFirstMessage,
      mailboxIndicatorNeeded,
      mailboxName,
      mailboxColor,
    } = this.props

    const isOutsideCommunication = message.isOutsideCommunication
    const isNote = message.isNote

    return (
      <div
        id={`changeset-${message.id}`}
        className={cn('changeset expanded', {
          forward: isOutsideCommunication,
        })}
      >
        <div className="action-container">
          <div
            className={cn('action', {
              message: !isNote,
              note: isNote,
              'fullstack-noteAction': isNote,
              forward: isOutsideCommunication,
            })}
          >
            <div className="contents">
              {!isNote && (
                <ExpandedMessageContent
                  message={message}
                  expandChangeset={this.expandChangeset}
                  currentUserId={currentUserId}
                  isFirstMessage={isFirstMessage}
                  mailboxIndicatorNeeded={mailboxIndicatorNeeded}
                  mailboxName={mailboxName}
                  mailboxColor={mailboxColor}
                  onOpenImage={onOpenImage}
                  onCopyLinkClick={this.onCopyLinkClick}
                  onPrintClick={this.onPrintClick}
                />
              )}
              {isNote && (
                <ExpandedNoteContent
                  message={message}
                  expandChangeset={this.expandChangeset}
                  currentUserId={currentUserId}
                  isFirstMessage={isFirstMessage}
                  onOpenImage={onOpenImage}
                  onCopyLinkClick={this.onCopyLinkClick}
                  onPrintClick={this.onPrintClick}
                />
              )}
            </div>
          </div>
        </div>
        <SubsequentActionsList
          message={message}
          currentUserId={currentUserId}
          integrationSettings={integrationSettings}
        />
      </div>
    )
  }
}

export default ExpandedMessageView
